import type { ComponentPropsWithoutRef } from 'react'

const ModalInner = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div className={`relative h-full px-5 ${className}`} {...props} />
)

export default ModalInner
